<template>
  <div class="default-confirm">
    <img
      v-if="icon"
      src="https://cdn.poizon.com/node-common/b71201311a82228e988ac88a02f89e76.png"
      class="default-confirm-icon"
    />
    <div v-if="title" class="default-confirm-title">{{ title }}</div>
    <div
      v-if="description"
      class="default-confirm-description"
      :style="descStyle"
      v-html="description"
    />
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    descStyle: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="sass" scoped>
.default-confirm
  display: flex
  flex-wrap: wrap
  align-items: center
  min-height: 60px

  &-icon
    width: 88px
    height: 88px
    margin: 0 auto
    margin-bottom: 24px

  &-title
    width: 100%
    margin-bottom: 24px
    color: rgb(20, 21, 26)
    font-size: 32px
    font-family: PingFangHK-Medium
    font-weight: 500
    text-align: center
    line-height: 44px

  &-description
    width: 100%
    max-height: 60vh
    text-align: center
    color: rgb(43, 60, 60)
    font-size: 28px
    font-family: PingFangHK-Regular
    font-weight: normal
    text-align: center
    line-height: 44px
    white-space: pre-line
    overflow: hidden auto
</style>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .default-confirm {
    min-height: 60px;
    .default-confirm-title {
      margin-bottom: 24px;
      font-size: 32px;
      line-height: 44px;
    }
    .default-confirm-description {
      max-height: 60vh;
      font-size: 28px;
      line-height: 44px;
    }
  }
}
</style>
